import * as React from 'react';
import { Tooltip } from 'components';
import { PortalFieldLabel } from 'components/FormControls';
import { IMeta } from 'models/common';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	input?: any;
	label?: any;
	type?: any;
	meta?: IMeta;
	autoFocus?: any;
	isDisabled?: boolean;
	showOffButtonOnDisabled?: boolean;
	onChangeAction?: any;
	tooltipText?: string;
	tooltipPosition?: any;
	/** alternative error UI */
	errorBelow?: boolean;
}

export const PortalSwitchField = (props: IProps) => {
	let labelContainer: JSX.Element = <PortalFieldLabel name={props.input.name} text={props.label} />;

	if (!props.label) {
		labelContainer = null;
	}

	const meta = props.meta || {};

	return (
		<div className={'portalSwitchField' + (meta.touched && meta.error ? ' withError' : '')}>
			<div className="switchInnerHolder">
				<input
					{...props.input}
					className={meta.touched && meta.error ? 'inputError' : ''}
					id={props.input.name}
					placeholder={props.label}
					type={props.type || 'checkbox'} // if used in redux-form be sure to define type as "checkbox"!!!! Else the mfer doesn't work
					autoFocus={props.autoFocus}
					disabled={props.isDisabled}
					onChange={(e) => {
						if (props.onChangeAction) {
							props.onChangeAction(e);
						}
						if (typeof props.input.onChange === 'function') {
							props.input.onChange(e);
						}
					}}
				/>
				{!props.errorBelow &&
					meta.touched &&
					((meta.error && <span className="requiredfield">{meta.error}</span>) ||
						(meta.warning && <span>{meta.warning}</span>))}
				{labelContainer}
				{props.tooltipText && props.tooltipText.length > 0 ? (
					<Tooltip position={props.tooltipPosition} message={props.tooltipText}>
						<a href="#" onClick={(e) => e.preventDefault()}>
							<img src={require('containers/Html/icons/tooltip-icon.png')} />
						</a>
					</Tooltip>
				) : null}
				<label htmlFor={props.input.name}>
					{!props?.showOffButtonOnDisabled ? (
						<div className="offIcon">{renderIcon(props.isDisabled ? 'offDisabled' : 'off')}</div>
					) : null}
					{props?.showOffButtonOnDisabled ? (
						<div className="offIconOnDisabled">{renderIcon(props.isDisabled ? 'offDisabled' : 'off')}</div>
					) : (
						<div className="onIcon">{renderIcon(props.isDisabled ? 'onDisabled' : 'on')}</div>
					)}
				</label>
				<div>{/*empty cell for error label*/}</div>
				{props.errorBelow && meta.touched && meta.error && (
					<div className="switchFieldErrors">
						<span className="note">{meta.error}</span>
					</div>
				)}
			</div>
		</div>
	);
};
